import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-year-data-chart',
  templateUrl: './year-data-chart.component.html',
  styleUrls: ['./year-data-chart.component.scss']
})
export class YearDataChartComponent implements OnInit {
  @Input() chartInfo: Object;

  public chartOptions: any;
  public chartLabels: any;
  public chartColors: any;
  public chartData: any;

  constructor() { }

  ngOnInit(): void {
    this.createChart();
  }

  public createChart() {
    this.chartOptions = {
      responsive: true,
    };

    this.chartLabels = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    this.chartColors = [{
        backgroundColor: "#28306e",
        borderColor: "#28306e",
    }];

    this.chartData = [
      {
        data: Object.values(this.chartInfo)
      }
    ];
  }
}
